<template>
  <div style="width:95%;margin:0 auto" v-if="payInfo.deposit_no">
    <div class="payType">充值</div>
    <div class="tit">1.请确认您选择进行充值的网路和提现网路相符，否则可能导致损失资产</div>

    <div class="tit">2.请务必确认电脑及浏览器安全，防止信息被篡改或泄密。</div>
    <!-- <div class="payType">{{ payInfo.info.bank }}</div> -->

    <div class="hg"><div>存款金额</div><div>{{ payInfo.info.amount }}CNY</div></div>
    <div class="hg"><div>预计到账</div><div>{{ payInfo.info.real_money }}{{ type == 'usdtpay'?'USDT':'CNY'}}</div></div>
    <div class="hg"><div>创建时间</div><div>{{payInfo.info.created_at}}</div></div>
        <div class="payType">{{ payInfo.cardlist.content }}</div>

    <img class="infoImg" :src="payInfo.cardlist.payimg" alt="">
    <div  class="scan__link" v-if='payInfo.info.bank'><span >{{ payInfo.cardlist.mch_id }}</span><a  @click="doCopy(payInfo.cardlist.mch_id)" href="javascript:void 0;" class="scan__copy">复制</a></div>
    <div style="height:120px"></div>
  </div>
</template>
<script>
export default {
  name: 'payInfo',
  data() {
    return {payInfo:{},type:''};
  },
  created() {
    let that = this;

    var query = that.$route.query;
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    getpayinfo(deposit_no) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(res.message);
        }
        if (res.code == 200) {

          that.payInfo = res.data;
          that.type = res.message;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.gold__link, .scan__link {
    position: relative;
    height: 35px;
    padding-right: 70px;
    margin-top: 5px;
    overflow: hidden;
    font-size: 14px;
    line-height: 35px;
    color: #333;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #f5f5f5;
    border-radius: 4px;
}
.gold__link, .scan__link {
    position: relative;
    height: 35px;
    padding-right: 70px;
    margin-top: 5px;
    overflow: hidden;
    font-size: 14px;
    line-height: 35px;
    color: #333;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #f5f5f5;
    border-radius: 4px;
}
.gold__copy, .scan__copy {
    position: absolute;
    top: 0;
    right: 0;
    width: 70px;
    height: 100%;
    color: #fff;
    text-align: center;
    background-color: #cca352;
    border-radius: 4px;
}
a {
    text-decoration: none;
    cursor: pointer;
}
.gold__tips, .scan__tips {
    margin-top: 15px;
    font-size: 12px;
    line-height: 17px;
    color: #999;
}
.payType {
    position: relative;
    height: 48px;
    font-size: 18px;
    line-height: 48px;
    color: #fff;
    text-align: center;
    border-bottom: 1px solid #f4f4f4;
    text-align: center;
}
.hg{
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: space-between;

}
.tit{
      margin-top: 15px;
    font-size: 12px;
    line-height: 17px;
    color: #999;
}
.infoImg{
  display: block;
  width: 80%;
  margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue